import { type AnyAction } from 'redux';
import { HIDE_MESSAGE, SHOW_MESSAGE } from '../../messages/framework/store/message-actions';

type State = Record<string, any>;

export default (state: State = {}, action: AnyAction): State => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return action.payload;
    case HIDE_MESSAGE:
      return {};
    default:
      return state;
  }
};
